
export const QuestionsEmpty = () => (
	<div
		className="rounded-md border border-dashed border-gray-200 py-10 text-center"
		data-testid="pre-compliance-questions-empty"
	>
		<p className="text-sm text-gray-500">
			No compliance questions yet. Add your first question below, or skip
			the compliance check.
		</p>
	</div>
);
